import { EVisitItem, IEVisitEvents, TEVisitOrder, TEVisitSlot } from 'types/e-visits';
import { AxiosResponse } from 'axios';
import { readableColor } from 'polished';
import { format } from 'date-fns';

export function convertGetEVisitsEventsResponse(
  resp: AxiosResponse<{ events: (TEVisitSlot | TEVisitOrder)[] }>,
) {
  // @ts-expect-error fuck
  const events = resp.data.data;
  const dates = events.reduce((acc: IEVisitEvents, curr: any) => {
    const date = new Date(curr.from);
    const key = `${format(date, 'yyyy-LL-dd')}` as keyof IEVisitEvents;

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(toFeType(curr));

    return acc;
  }, {} as IEVisitEvents) as IEVisitEvents;

  return {
    ...resp,
    data: {
      data: {
        dates,
      },
    },
  };
}

function toFeType(eventFromApi: TEVisitSlot | TEVisitOrder): EVisitItem {
  const visitEvent = {} as EVisitItem;

  visitEvent.event = {
    eventId: eventFromApi.extraData.eventId,
    from: eventFromApi.from as unknown as string,
    to: eventFromApi.to as unknown as string,
    description: eventFromApi.description,
    expertiseCode: eventFromApi.expertiseCode,
    // @ts-expect-error haha
    extraData: eventFromApi.extraData,
    medicalInstitutionId: eventFromApi.medicalInstitutionId,
    title: eventFromApi.title,
    tag: eventFromApi.tag,
  };

  if (eventFromApi.type === 'eVisitOrder') {
    visitEvent.order = {
      id: eventFromApi.extraData.id,
      patientUserId: eventFromApi.extraData.patientUserId,
      patientDescription: eventFromApi.extraData.patientDescription,
      patientProfile: eventFromApi.extraData.patient,
      tag: (eventFromApi as TEVisitOrder).tag,
    };
  }

  return visitEvent;
}

export function getTagColors(color: string) {
  return {
    backgroundColor: color,
    textColor: readableColor(color),
  };
}
